export enum OperationType {
    Create = 'create',
    Update = 'update',
    Delete = 'delete',
}
